import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Router } from "@angular/router";
import { _throw } from "rxjs/observable/throw";
import "rxjs/add/operator/timeout";
import "rxjs/add/operator/do";
import "rxjs/add/operator/catch";
import { SeusStatusService } from '../services/seus-status.service';

@Injectable()
export class HttpIntercepted implements HttpInterceptor {
  constructor(
    private router: Router,
    private seusStatusService: SeusStatusService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Clono el request para agregar el header del location
    const headers = request.headers.set("X-APP-RELAYSTATE", location.href);
    const clonedRequest = request.clone({ headers, withCredentials: true });

    // Configurar timeout para detectar problemas de conectividad(60 segundos)
    const timeoutDuration = 60000;

    // Evitar bucle infinito: no interceptar si ya estamos en acceso-denegado
    const isAccessDeniedPage = location.hash.includes('acceso-denegado');

    return next.handle(clonedRequest)
      .timeout(timeoutDuration)
      .do(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // Respuesta exitosa (200) - marcar SEUS como disponible
            if (event.status === 200) {
              this.seusStatusService.markSeusAvailable();
            }
          }
        },
        (err: any) => {
          // No redirigir si ya estamos en la página de acceso denegado
          if (isAccessDeniedPage) {
            return _throw(err);
          }

          // Manejar errores HTTP y de conectividad
          if (err instanceof HttpErrorResponse) {
            console.error('Error HTTP interceptado:', err);

            switch (err.status) {
              case 401:
                // Cuando SEUS responde con 401
                const body = document.getElementsByTagName("body")[0];
                body.innerHTML = err.error.toString();
                const form = document.getElementsByTagName("form")[0];
                if (form) {
                  form.submit();
                }
                break;

              case 403:
                // Cuando SEUS responde con 403 - problema de permisos
                this.seusStatusService.markSeusUnavailable('server', err.status);
                this.navigateToErrorPage('server', err.status);
                break;

              case 503:
                // Servicio no disponible - mostrar acceso denegado
                console.warn('Servicio no disponible (503)');
                this.seusStatusService.markSeusUnavailable('service_unavailable', err.status);
                this.navigateToErrorPage('service_unavailable', err.status);
                break;

              case 0:
                // Error de red/conectividad - mostrar acceso denegado
                console.warn('Error de conectividad con los servicios');
                this.seusStatusService.markSeusUnavailable('network', err.status);
                this.navigateToErrorPage('network', err.status);
                break;

              case 406:
                break;

              case 409:
                break;

              default:
                // Para otros errores HTTP del servidor (5xx), verificar si es problema con SEUS
                if (err.status >= 500 && err.status < 600) {
                  // Errores del servidor - posible problema con SEUS
                  console.warn(`Error del servidor SEUS (${err.status})`);
                  this.seusStatusService.markSeusUnavailable('server', err.status);
                  this.navigateToErrorPage('server', err.status);
                } else {
                  // Otros errores, propagar sin redireccionar
                  console.error('Error HTTP no manejado:', err.status, err.message);
                }
                break;
            }
          } else if (err.name === 'TimeoutError') {
            // Timeout - problema de conectividad con SEUS
            console.warn('Timeout al conectar con servicios SEUS');
            this.seusStatusService.markSeusUnavailable('timeout', 0);
            this.navigateToErrorPage('timeout', 0);
          } else {
            // Otros tipos de error (red, etc.) - problema de conectividad con SEUS
            console.warn('Error de conectividad con servicios SEUS:', err);
            this.seusStatusService.markSeusUnavailable('network', 0);
            this.navigateToErrorPage('network', 0);
          }
          return _throw(err);
        }
      );
  }

  private navigateToErrorPage(tipo: string, status: number): void {
    // Navegar con query parameters para pasar la información del error
    this.router.navigate(['acceso-denegado'], {
      queryParams: {
        tipo: tipo,
        status: status
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/http/http.intercepted.ts